import styled, { css } from 'styled-components';
import {
  Button as BaseButton,
  Colors,
  TextInput as BaseTextInput,
  BodyHeavy,
  MediaQuery,
  Theme,
  BodyLight,
  H2Heavy,
  Icon,
} from '@pelando/components';

export const TextInput = styled(BaseTextInput)`
  background-color: ${({ theme }) => theme.colors.Juliet};
`;

export const Button = styled(BaseButton)`
  ${BodyHeavy};
  height: 48px;
  background-color: rgb(${Theme.colors.Brand});
  border-radius: 36px;
  width: 100%;
  padding: 8px 24px;
  margin-top: 16px;
  outline: none;
  &:focus-visible {
    outline: 1px solid rgb(${Colors.Coal});
  }
`;

export const EditNicknameModalStyle = css`
  padding: 24px;
  @media ${MediaQuery.SCREEN_MD_UP} {
    min-width: 391px;
  }
`;

export const IconTitle = styled(Icon)`
  color: rgb(${Theme.colors.Brand});
  font-size: 48px;
  margin-bottom: 24px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    margin-bottom: 16px;
  }
`;

export const Title = styled.h3`
  ${H2Heavy}
  margin-bottom: 8px;
  width: 343px;
`;

export const Subtitle = styled.p`
  ${BodyLight}
  color: rgb(${Colors.Gray});
  margin-bottom: 24px;
  text-align: center;
  width: 343px;
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
`;
